import type { AuthenticationError } from './AuthContext';

export type TrackError = (
  label: string,
  error?: Error,
  data?: {
    [k: string]: unknown;
  },
) => void;

export function authenticationRequestError(
  error: unknown,
  trackError: TrackError | undefined,
): AuthenticationError {
  const message = 'Session request failed';
  // Transport errors can embed session credentials in their message, cause, and payload.
  trackError?.('Session error', new Error(message), {
    errorName: error instanceof Error ? error.name : 'Error',
  });
  return { state: 'error', user: undefined, message };
}
